import { render, staticRenderFns } from "./CurriculumSelector.vue?vue&type=template&id=49ff1381"
import script from "./CurriculumSelector.vue?vue&type=script&lang=js"
export * from "./CurriculumSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports